import manifest from '../data.manifest.json';
import airportsJson from './airports-core.json';
import type { Airport } from '../schemas/airport';

/**
 * Курируемое ядро аэропортов. JSON сгенерирован из airports-core.csv скриптом
 * scripts/build.ts; форма проверена zod при генерации и тестами, поэтому в
 * рантайме повторная валидация не нужна.
 */
export const AIRPORTS_CORE = airportsJson as readonly Airport[];

export const DATA_MANIFEST = manifest;

const BY_IATA = new Map(AIRPORTS_CORE.map((a) => [a.iata, a]));

export function airportByIata(iata: string): Airport | undefined {
  return BY_IATA.get(iata.toUpperCase());
}

export type { Airport };
